import React from 'react';

export const MoonIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={className} style={style}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

export const SunIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className} style={style}>
    <circle cx="12" cy="12" r="5" strokeWidth="2" />
    <line x1="12" y1="1" x2="12" y2="3" strokeWidth="2" />
    <line x1="12" y1="21" x2="12" y2="23" strokeWidth="2" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" strokeWidth="2" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" strokeWidth="2" />
    <line x1="1" y1="12" x2="3" y2="12" strokeWidth="2" />
    <line x1="21" y1="12" x2="23" y2="12" strokeWidth="2" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" strokeWidth="2" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" strokeWidth="2" />
  </svg>
);

export const SpeakerIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className={className} style={style}>
    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/>
    <path d="M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
  </svg>
);

export const ZoomInIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className} style={style}>
    <circle cx="11" cy="11" r="8" strokeWidth="2"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65" strokeWidth="2"/>
    <line x1="11" y1="8" x2="11" y2="14" strokeWidth="2"/>
    <line x1="8" y1="11" x2="14" y2="11" strokeWidth="2"/>
  </svg>
);
